import React from 'react';
import { Table, Modal, Button, Popup,Icon } from 'semantic-ui-react';
import { NoData } from "../../../components/table/no-data";
import * as api from '../../../api';
import { withRouter } from 'react-router-dom';
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../../../authConfig";
import { withMsal } from "@azure/msal-react";
import { AuthService } from "../../../services/auth-service";
import { toast } from 'react-toastify';
import EditUserModal from './users/edit-user-modal'
import FormattedDate from "../../../components/formatters/formattedDate";

const pca = new PublicClientApplication(msalConfig);


class UserTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            delBtnOpen: false,
            open: false,
            toggledTab: false,
            firstName: '',
            surname: '',
            userId: '',
            role: '',
            isReadOnly: false,
            DashboardUser: false,
            isFundLevel: false,
        };
        this.authService = new AuthService();

    }

    triggerImpersonationFlow = (userName) => {
        const account = pca.getAllAccounts()[0];

        const accessTokenRequest = {
            scopes: ["user.read"],
            account: account
        }

        pca.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse) => {
            // Acquire token silent success
            let accessToken = accessTokenResponse.accessToken;


            this.authService
                .authenticateImpersonationDomainUser(accessTokenResponse.account.username, accessToken, userName)
                .then((res) => {


                    this.authService.cacheUserData(res)

                    this.props.history.push("/");
                    window.location.reload();


                })
                //.then(this.notifyParent)
                .catch((error) => {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                });
            // Call your API with token
            //callApi(accessToken);
        }).catch(function (error) {
            //Acquire token silent failure, and send an interactive request
            pca.acquireTokenPopup(accessTokenRequest).then(function (accessTokenResponse) {
                // Acquire token interactive success
                // Call your API with token
                //callApi(accessToken);
            }).catch(function (error) {
                // Acquire token interactive failure
                console.log(error);
            });
            console.log(error);
        });

    }
    setModalOpen = () => {
        this.setState({ open: true, toggledTab: false })
    }

    setModalClose = () => {
        this.setState({ open: false, toggledTab: false })
    }

    handleEditUser = (data) => {

        this.setState({ firstName: data.firstName, surname: data.surname, userId: data.username, open: true })
    }
    onInputChange = (event, { name, value }) => {

        this.setState({ [name]: value })

    }
    handleUserRole = (event, { name, value }) => {

        let clientUserAll = this.props.rolesList.filter((item) => { return (item.roleName === "Client User All") })
        let clientUser = this.props.rolesList.filter((item) => { return (item.roleName === "Client User") })

        if (value === clientUserAll[0].roleId) { this.setState({ toggledTab: true }) }
        if (value === clientUser[0].roleId) { this.setState({ toggledTab: false }) }


    }
    onCheckboxChange = (event, { name, checked }) => {

        this.setState({ [name]: checked })
    }

    handleUserSubmit = () => {

        if (this.state.firstName === '' || this.state.lastName === '' || this.state.userId === '') {
            return
        }
        const formData = new FormData();


        formData.append("username", this.state.userId);
        formData.append("isFundLevel", this.state.isFundLevel);
        formData.append("isReadOnly", this.state.isReadOnly);
        formData.append("firstName", this.state.firstName);
        formData.append("surname", this.state.surname);
        formData.append("clientId", this.props.contextData.customerId)
        formData.append("userDirectory", "INSITE")
        formData.append("userId", this.state.userId);
        formData.append("userPrincipalName", this.state.userId);
        formData.append("dashboardUser", this.state.DashboardUser);


        try {
            api.updateUser(this.state.userId, formData)
                .then(verifyRes => {

                    if (verifyRes.status === "Success") {
                        this.setState({ open: false, toggledTab: false });
                        this.props.onEditTrigerRefresh();
                        this.notify();
                    }

                })
           
        } catch (err) {
            console.log(err)
        }

        this.setState({
            firstName: '',
            surname: '',
            userId: '',
            role: '',
            isReadOnly: false,
            DashboardUser: false,
            isFundLevel: false,
        })
    }
    notify = () => {
        toast.success("Successfully saved !", {
            position: toast.POSITION.TOP_CENTER,
            delay: 500
        });
    }
    notifyToDeletedRecord = () => {
        toast.warning("Successfully deleted !", {
            position: toast.POSITION.TOP_CENTER,
            delay: 500
        });
    }

    translateActive = (lastActive) => {
        if(lastActive === "1753-01-01T00:00:00")
        {
            return "Never"
        }else 
        {
            return lastActive
        }
    }

    translateStatus = (isReset, inviteSent, dashboardUser, username, lastActive) => {
       

        if(!inviteSent)
        {
            return "Awaiting Invite";
        }
        else if(username !=null && username.indexOf("inenco.com") !== -1)
        {
            return "Admin Active";
        }else if(dashboardUser && isReset) //Legacy Reverse code(Woeful and need to fix)
        {
            return "Awaiting Login";
        }else if(lastActive === "1753-01-01T00:00:00")
        {
            return "Invite Sent";
        }else 
        {
            return "Active"
        }

    

    }

    deleteUserRecord = () => {

        api.deleteUser(this.props.data.id)
            .then((data) => {
                if (data.status === "Success") {
                    this.notifyToDeletedRecord();
                    this.setState({ delBtnOpen: false });
                    this.props.onEditTrigerRefresh();
                }
            }).catch((error) => {

            })
    }
    render() {
        return (
            <Table.Row>
                <Table.Cell>{this.props.data.username || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.firstName || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.surname || <NoData />}</Table.Cell>

                <Table.Cell>{this.translateActive(this.props.data.lastActive) !== 'Never' ? <FormattedDate value={this.props.data.lastActive} outputFormat="DD/MM/YYYY hh:mm" inputFormat="YYYY-MM-DDThh:mm:ss"/> : this.translateActive(this.props.data.lastActive)}</Table.Cell>


                <Table.Cell><FormattedDate value={this.props.data.createdDate} outputFormat="DD/MM/YYYY hh:mm" inputFormat="YYYY-MM-DDThh:mm:ss"/></Table.Cell> 
                <Table.Cell>{this.translateStatus(this.props.data.isReset,this.props.data.inviteSent, this.props.data.dashboardUser, this.props.data.username, this.props.data.lastActive) || <NoData />}</Table.Cell>
                <Table.Cell>
  {this.props.data.latestPortalPolicyAccepted ? 
    <Icon name="checkmark box" /> : 
    (this.props.data.username.includes("inenco.com") ? "N/A" : <Icon name="square outline" />)
  }
</Table.Cell>
                <Table.Cell>

                    <EditUserModal
                        open={this.state.open}
                        data={this.props.data}
                        rolesList={this.props.rolesList}
                        setModalOpen={this.setModalOpen}
                        setModalClose={this.setModalClose}
                        handleEditUser={this.handleEditUser}
                        onInputChange={this.onInputChange}
                        onCheckboxChange={this.onCheckboxChange}
                        handleUserSubmit={this.handleUserSubmit}
                        toggledTab={this.state.toggledTab}
                        handleUserRole={this.handleUserRole}
                        {...this.props}
                    />
                    <Modal
                        onClose={() => this.setState({ delBtnOpen: false })}
                        onOpen={() => this.setState({ delBtnOpen: true })}
                        open={this.state.delBtnOpen}
                        size={'mini'}
                        trigger={<Popup
                            trigger={<Button circular color='red' icon='trash alternate outline' className="custom-mrg" onClick={() => this.setState({ delBtnOpen: true })} />}
                            position="top center"
                        >
                            Delete
                        </Popup>}
                    >
                        <Modal.Header>Are you sure?</Modal.Header>
                        <Modal.Content>
                            <Modal.Description>
                                <p>
                                    Do you really want to delete this record?
                                </p>
                            </Modal.Description>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button positive color='black' onClick={() => this.setState({ delBtnOpen: false })}>Cancel</Button>
                            <Button content="Delete"
                                onClick={this.deleteUserRecord}
                                negative
                            />
                        </Modal.Actions>
                    </Modal>
                    <Popup
                            trigger={<Button circular color='green' icon='eye' className="custom-mrg" onClick={() => this.triggerImpersonationFlow(this.props.data.username)} ></Button>}
                            position="top center"
                            >
                                Impersonate
                            </Popup>
                </Table.Cell>
            </Table.Row>
        );
    }
}


export default withMsal(withRouter(UserTableRow));

